import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { BrandingField } from '@app/core/models/branding.models';
import { AppFeature } from '@app/core/models/config.models';
import { AppConfigService } from '@app/core/services/app-config.service';
import { BrandingColorDirective } from '@app/shared/directives/branding-color.directive';
import { AssetUrlPipe } from '@app/shared/pipes/asset-url.pipe';
import { macAppDownloadUrl, windowsAppDownloadUrl } from '@app/shared/utils/update.util';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    BrandingColorDirective,
    AssetUrlPipe,
  ],
})
export class AppsComponent {
  protected readonly AppFeature = AppFeature;
  protected readonly BrandingField = BrandingField;
  constructor(protected appConfigService: AppConfigService) {
    this.appConfigService.getLoginQRCode().then();
  }

  downloadWindows() {
    window.open(windowsAppDownloadUrl, '_blank');
  }

  downloadMacOS() {
    window.open(macAppDownloadUrl, '_blank');
  }
}
